var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.openAlertModal}},[(_vm.isFollowUpPage)?_c('a',{staticClass:"button"},[_vm._v("Start follow up")]):_c('img',{staticClass:"alert_button btn",attrs:{"src":"/clock.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }